import type { ListMemoryThreadsResponse } from '@mastra/client-js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FALLBACK_THREAD_TITLE, rememberProvisionalThreadTitle } from '../lib/threadTitle';

const THREADS_QUERY_KEY = ['AI', 'THREADS'];

/**
 * Hook to add a thread optimistically to the cache
 * @param agentName - The agent ID
 * @param resourceId - The resource ID or user ID
 * @returns Mutation function to add optimistic thread
 */
export const useCreateFakeThread = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ threadId, prompt }: { threadId: string; prompt?: string }) => {
      rememberProvisionalThreadTitle(threadId, prompt);
      // Optimistically add the new thread to every cached thread list.
      queryClient.setQueriesData({ queryKey: THREADS_QUERY_KEY }, (oldData: ListMemoryThreadsResponse | undefined) => {
        if (!oldData?.threads) return oldData;

        const newThread = {
          id: threadId,
          title: FALLBACK_THREAD_TITLE,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };

        return {
          ...oldData,
          threads: [newThread, ...oldData.threads.filter((thread) => thread.id !== threadId)],
        };
      });
    },
  });
};
